module.exports = __webpack_public_path__ + "static/media/discover.acb2f470.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/discover.svg
// module id = 492
// module chunks = 0